import querystring from 'querystring';

import api from './api';
import store from '../../store';
import { LOADS_API_URL } from '../../env';
import { getFilterParams } from '../mappers';

const loadBoardUrl = LOADS_API_URL;

const getLoadBoardUrl = `${loadBoardUrl}/LoadBoard/GetLoadBoard`;
const getFilterSuggestionsUrl = `${loadBoardUrl}/LoadBoard/GetFilterSuggetions`;

export async function getLoadBoard(skip, take, sort, filters, search) {
  const sortBy = sort?.length > 0 ? sort[0].colId : undefined;
  const sortDir = sort?.length > 0 ? sort[0].sort : undefined;
  const cleanedSortBy = sortBy?.replace('_1', '');
  const filterParams = getFilterParams(filters);
  const searchTerm = search || undefined;
  const offices = store.getState().profileSettings.data?.officeNames;

  const params = {
    skip,
    take,
    ...filterParams,
    sortBy: cleanedSortBy,
    sortDir,
    searchTerm,
    offices,
  };

  // Remove undefined params because the serializer includes them by default
  Object.keys(params).forEach((key) => params[key] === undefined && delete params[key]);

  const options = {
    url: getLoadBoardUrl,
    params,
    paramsSerializer: (parameters) => querystring.stringify(parameters),
  };
  return api.get(options);
}

export async function getFilterSuggestions(field, term) {
  const offices = store.getState().profileSettings.data?.officeNames;
  const mode = store.getState().modeType.type;
  const params = {
    field,
    term,
    offices,
    modeType: mode,
  };

  Object.keys(params).forEach((key) => params[key] === undefined && delete params[key]);

  const options = {
    url: getFilterSuggestionsUrl,
    params,
    paramsSerializer: (parameters) => querystring.stringify(parameters),
  };
  return api.get(options);
}
